import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export enum BypassType {
  ResourceUrl = 'resourceUrl',
  TrustHtml = 'trustHtml',
}

@Pipe({
  name: 'safeTemplate',
  standalone: true,
})
export class SafeTemplatePipe implements PipeTransform {
  private sanitizer: DomSanitizer = inject(DomSanitizer);

  transform(value: string | undefined, type?: BypassType): SafeHtml {
    if (!value) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    switch (type) {
      case BypassType.ResourceUrl:
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      case BypassType.TrustHtml:
        return this.sanitizer.bypassSecurityTrustHtml(value);
      default:
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
  }
}
